// extracted by mini-css-extract-plugin
export default {"termsAndConditions":"SignUp_termsAndConditions__jW+JO","title":"SignUp_title__wuW2N","wrapper":"SignUp_wrapper__r4tk3","info":"SignUp_info__luApR"};